import styled from "@emotion/styled"
import type { Room } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  isOneTab?: boolean
  room?: Room
  sidebarOpen?: boolean
  servicePanelBackgroundColor?: string
  isExpandIcon?: boolean
}

export const Root = styled.div<StylesProps>`
  display: flex;
  position: ${({ isOneTab }) => (isOneTab ? "absolute" : "unset")};
  bottom: ${({ isOneTab }) => isOneTab && "3px"};
  right: ${({ isOneTab }) => isOneTab && "0px"};
  /* left: ${({ isOneTab }) => isOneTab && "-53px"}; */
  flex-direction: column;
  justify-content: end;
  margin-bottom: 1rem;
  z-index: 100000;
  background-color: transparent;
  width: ${({ isOneTab }) => isOneTab ? "32px": "75px"};
  flex: 1;
  align-items: center;
  &:hover {
    color: black;
  }
`

export const IconContainer = styled.div<StylesProps>`
  flex-direction: ${({ isExpandIcon }) => isExpandIcon && "column"};
  display: flex;
  height: 100%;
  margin-top: auto;
  position: relative;
  background-color: ${({ servicePanelBackgroundColor }) =>
    servicePanelBackgroundColor && servicePanelBackgroundColor};
  border-top-left-radius: ${({ isOneTab }) => isOneTab && "0.375rem"};
  border-bottom-left-radius: ${({ isOneTab }) => isOneTab && "0.375rem"};
`
